export default __webpack_public_path__ + "static/media/electronics-showcase.c748eaed.webp";